var _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidTier3Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 80,
    viewBox: "0 0 94 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9157 78.1575L90.3996 59.4411C92.1457 58.5681 93.0198 56.8867 93.022 55.2043V50.0381H0.382812V55.2043C0.38497 56.8867 1.2591 58.5681 3.0052 59.4411L39.4891 78.1575C44.03 80.4279 49.3748 80.4279 53.9157 78.1575Z",
    fill: "url(#paint0_linear_8129_25797)",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4891 27.152C44.03 24.8816 49.3748 24.8816 53.9157 27.152L90.3996 45.394C93.8961 47.1423 93.8961 52.132 90.3996 53.8802L53.9157 72.1222C49.3748 74.3926 44.03 74.3926 39.4891 72.1222L3.0052 53.8802C-0.491315 52.132 -0.49132 47.1423 3.0052 45.394L39.4891 27.152Z",
    fill: "url(#paint1_linear_8129_25797)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9171 72.1226L90.401 53.8806C91.9925 53.0848 92.8596 51.6174 93.0023 50.0898C91.9569 52.4824 91.5233 52.6269 90.2016 53.4133L53.8041 71.4212C52.7677 71.8855 49.9508 73.0922 46.5222 73.0922C43.0936 73.0922 40.4735 71.8855 39.5582 71.4212C27.8662 65.564 4.13278 53.9776 3.00657 53.3776C1.88036 52.7775 0.887103 51.4248 0.53125 50.8235C0.847222 52.0744 1.67233 53.2135 3.00657 53.8806L39.4905 72.1226C44.0313 74.393 49.3762 74.393 53.9171 72.1226Z",
    fill: "url(#paint2_linear_8129_25797)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8129_25797)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bi_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6466 16.8997C44.6733 14.8863 49.4129 14.8863 53.4396 16.8996L85.792 33.0759C88.8926 34.6262 88.8926 39.0508 85.792 40.6011L53.4396 56.7774C49.4129 58.7907 44.6733 58.7907 40.6466 56.7774L8.29418 40.6011C5.19361 39.0508 5.1936 34.6262 8.29418 33.0759L40.6466 16.8997Z",
    fill: "url(#paint3_linear_8129_25797)",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bi_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.96875 36.8389V42.218C5.97066 43.7099 6.74581 45.2009 8.29418 45.9751L40.6466 62.572C44.6733 64.5854 49.4129 64.5854 53.4396 62.572L85.792 45.9751C87.3404 45.2009 88.1156 43.7099 88.1175 42.218V36.848C88.1143 38.3387 87.3392 39.8279 85.7921 40.6015L53.4396 56.7777C49.4129 58.7911 44.6733 58.7911 40.6466 56.7777L8.29418 40.6015C6.7439 39.8263 5.96875 38.3326 5.96875 36.8389Z",
    fill: "url(#paint4_linear_8129_25797)",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.442 56.777L85.7944 40.6008C87.2058 39.8951 87.9747 38.5939 88.1012 37.2393C87.1742 39.3609 86.7897 39.489 85.6176 40.1863L53.3418 56.1551C52.4228 56.5668 49.9249 57.6368 46.8845 57.6368C43.8441 57.6368 41.5208 56.5668 40.7091 56.1551C30.3411 50.9611 9.29526 40.6867 8.29658 40.1547C7.2979 39.6226 6.41712 38.4231 6.10156 37.8898C6.38175 38.9991 7.11343 40.0092 8.29658 40.6008L40.649 56.777C44.6757 58.7903 49.4153 58.7903 53.442 56.777Z",
    fill: "url(#paint5_linear_8129_25797)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_8129_25797)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_bi_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7313 8.80305C44.8597 7.23883 48.542 7.23883 51.6705 8.80304L76.806 21.3708C79.2149 22.5753 79.2149 26.0129 76.806 27.2174L51.6705 39.7852C48.542 41.3494 44.8597 41.3494 41.7313 39.7852L16.5958 27.2174C14.1868 26.0129 14.1868 22.5753 16.5958 21.3708L41.7313 8.80305Z",
    fill: "url(#paint6_linear_8129_25797)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_bi_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7891 24.2939V29.6117C14.7905 30.7708 15.3928 31.9292 16.5958 32.5307L41.7313 45.4253C44.8597 46.9895 48.542 46.9895 51.6705 45.4253L76.806 32.5307C78.009 31.9292 78.6112 30.7708 78.6127 29.6117V24.301C78.6102 25.4592 78.008 26.6162 76.806 27.2172L51.6705 39.785C48.542 41.3492 44.8597 41.3492 41.7313 39.785L16.5958 27.2172C15.3913 26.615 14.7891 25.4545 14.7891 24.2939Z",
    fill: "#E4E8F3",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6785 39.7849L76.8141 27.2171C77.9106 26.6689 78.508 25.6579 78.6062 24.6055C77.886 26.2538 77.5873 26.3534 76.6767 26.8951L51.6007 39.3017C50.8867 39.6216 48.946 40.4529 46.5838 40.4529C44.2217 40.4529 42.4166 39.6216 41.786 39.3017C33.7308 35.2663 17.3797 27.2839 16.6038 26.8705C15.8279 26.4572 15.1436 25.5252 14.8984 25.1109C15.1161 25.9727 15.6846 26.7575 16.6038 27.2171L41.7393 39.7849C44.8678 41.3491 48.5501 41.3491 51.6785 39.7849Z",
    fill: "url(#paint7_linear_8129_25797)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_8129_25797)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_bi_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7649 1.73256C45.0908 0.569618 47.8285 0.569616 50.1544 1.73255L68.8417 11.0762C70.6327 11.9717 70.6327 14.5275 68.8417 15.423L50.1544 24.7666C47.8285 25.9296 45.0908 25.9296 42.7649 24.7666L24.0776 15.423C22.2866 14.5275 22.2866 11.9717 24.0776 11.0762L42.7649 1.73256Z",
    fill: "url(#paint8_linear_8129_25797)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_bi_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7344 13.25V17.6444C22.7355 18.5062 23.1832 19.3674 24.0776 19.8146L42.7649 29.4013C45.0908 30.5642 47.8285 30.5642 50.1544 29.4013L68.8417 19.8146C69.7361 19.3674 70.1838 18.5062 70.1849 17.6444V13.2553C70.1831 14.1163 69.7354 14.9765 68.8417 15.4234L50.1544 24.767C47.8285 25.93 45.0908 25.93 42.7649 24.767L24.0776 15.4234C23.1821 14.9756 22.7344 14.1128 22.7344 13.25Z",
    fill: "url(#paint9_linear_8129_25797)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_8129_25797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1572 24.7668L68.8445 15.4231C69.6597 15.0155 70.1039 14.2639 70.1769 13.4814C69.6415 14.7069 69.4194 14.781 68.7424 15.1837L50.0993 24.4075C49.5685 24.6454 48.1256 25.2634 46.3695 25.2634C44.6133 25.2634 43.2713 24.6454 42.8024 24.4075C36.8137 21.4074 24.6572 15.4728 24.0804 15.1654C23.5035 14.8581 22.9948 14.1652 22.8125 13.8572C22.9743 14.4979 23.397 15.0814 24.0804 15.4231L42.7677 24.7668C45.0936 25.9297 47.8313 25.9297 50.1572 24.7668Z",
    fill: "url(#paint10_linear_8129_25797)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8129_25797",
    x: 0.382812,
    y: 49.8009,
    width: 92.6387,
    height: 30.0595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.237197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.237197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_8129_25797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8129_25797",
    x: -10.794,
    y: 14.2724,
    width: 114.992,
    height: 70.7295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.58839
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25797",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8129_25797",
    x: 0.195947,
    y: 49.7545,
    width: 93.1413,
    height: 24.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167652,
    result: "effect1_foregroundBlur_8129_25797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8129_25797",
    x: 1.47522,
    y: 15.3896,
    width: 91.1355,
    height: 57.6794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.49353
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24676
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25797",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bi_8129_25797",
    x: -4.71744,
    y: 4.70346,
    width: 103.521,
    height: 64.2703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.34309
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25797",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.210337
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.210337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bi_8129_25797",
    x: -2.44474,
    y: 28.4254,
    width: 98.9754,
    height: 44.0701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.20674
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25797",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.210337
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.210337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_8129_25797",
    x: 5.68089,
    y: 36.8186,
    width: 82.8413,
    height: 21.8892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.210337,
    result: "effect1_foregroundBlur_8129_25797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_8129_25797",
    x: 10.7434,
    y: 7.62988,
    width: 71.9155,
    height: 47.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.04563
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02281
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25797",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_bi_8129_25797",
    x: 5.27946,
    y: -1.87972,
    width: 82.8434,
    height: 52.3478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.7548
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25797",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.163417
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_bi_8129_25797",
    x: 8.25239,
    y: 17.7573,
    width: 76.8976,
    height: 35.378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.26834
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25797",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.163417
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_8129_25797",
    x: 14.5716,
    y: 24.2786,
    width: 64.3607,
    height: 17.0062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163417,
    result: "effect1_foregroundBlur_8129_25797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_8129_25797",
    x: 19.0211,
    y: 0.860352,
    width: 54.8777,
    height: 36.8396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.71324
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.85662
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25797",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_bi_8129_25797",
    x: 17.8746,
    y: -3.99943,
    width: 57.1707,
    height: 34.4979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.42989
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25797",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.121495
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_bi_8129_25797",
    x: 17.8746,
    y: 8.39022,
    width: 57.1707,
    height: 26.743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.42989
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25797",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.121495
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25797"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_8129_25797",
    x: 22.5695,
    y: 13.2385,
    width: 47.8512,
    height: 12.6437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121495,
    result: "effect1_foregroundBlur_8129_25797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8129_25797",
    x1: 93.022,
    y1: 52.6907,
    x2: 0.382813,
    y2: 52.6907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D8E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8129_25797",
    x1: 93.022,
    y1: 49.6371,
    x2: -1.03506,
    y2: 49.6371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8129_25797",
    x1: 0.53125,
    y1: 50.0898,
    x2: 93.0023,
    y2: 50.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8129_25797",
    x1: 88.1175,
    y1: 36.8385,
    x2: 5.96875,
    y2: 36.8385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E8F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8129_25797",
    x1: 88.1175,
    y1: 40.7778,
    x2: 5.96875,
    y2: 40.7778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C9D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8129_25797",
    x1: 6.10156,
    y1: 37.2393,
    x2: 88.1012,
    y2: 37.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8129_25797",
    x1: 80.3694,
    y1: 24.2941,
    x2: 14.7891,
    y2: 24.2941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E8F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8129_25797",
    x1: 14.8984,
    y1: 24.6055,
    x2: 78.6063,
    y2: 24.6055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white",
    stopOpacity: 0.865636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8129_25797",
    x1: 59.715,
    y1: 6.7398,
    x2: 20.9153,
    y2: 13.2496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E8F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8129_25797",
    x1: 71.257,
    y1: 17.1739,
    x2: 21.3513,
    y2: 16.1166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E8F3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8129_25797",
    x1: 22.8125,
    y1: 13.4814,
    x2: 70.177,
    y2: 13.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white",
    stopOpacity: 0.865636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidTier3Icon);
export default __webpack_public_path__ + "static/media/bfid-tier_3-icon.36256b5236f62a355272da3c7cc514dd.svg";
export { ForwardRef as ReactComponent };